<template>
  <card>
    <list
      v-if="$store.state.user.sections['sections']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "section",
      fields: [
        {
          label: "Название экрана",
          key: "name",
          type: "field",
        },
        {
          label: "Код экрана",
          key: "code",
          type: "field",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_section",
      itemLink: "sections",
      setLink: "sections",
      columns: [
        {
          key: "name",
          title: "Название экрана",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          //remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
